import AccountType from '../account/AccountType';
import recognition from './recognition';
import { Account } from '../types';

export default {
  CREATE_CLIENT: {
    scope: 'client.admin',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  VIEW_CLIENTS: {
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  CREATE_AGENCY: {
    scope: 'agency.admin',
    accountTypes: [AccountType.SERVICE_PROVIDER],
  },
  VIEW_AGENCIES: {
    scope: 'agency.admin',
    accountTypes: [AccountType.SERVICE_PROVIDER],
  },
  EDIT_ACCOUNT: {
    scope: 'account',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
    check(account: Account) {
      if (recognition.isAgency() && account.parentId === recognition.getAccountId()) {
        return true;
      }
      if (account.id === recognition.getAccountId()) {
        return true;
      }
      return recognition.isServiceProvider();
    },
  },
  FIND_ACCOUNTS: {
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  ENABLE_ACCOUNT_SERVICE: {
    scope: 'service',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
    check(accountId) {
      return !(accountId === recognition.getAccountId());
    },
  },
  DISABLE_ACCOUNT_SERVICE: {
    scope: 'service',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
    check(accountId) {
      return !(accountId === recognition.getAccountId());
    },
  },
  CHANGE_PASSWORD: {
    scope: 'user',
  },
  EDIT_USER: {
    scope: 'user',
  },
  INVITE_USER: {
    scope: 'users',
  },
  REINVITE_USER: {
    scope: 'users',
  },
  DELETE_USER: {
    scope: 'users',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY, AccountType.COMPANY],
    check(id: string): boolean {
      const appUserId = recognition.getUserId();
      if (!appUserId) return false;
      // eslint-disable-next-line eqeqeq
      return (appUserId != id);
    },
  },
  FIND_USER_INVITATION: {
    scope: 'users',
  },
  FIND_USER_INVITATIONS: {
    scope: 'users',
  },
  FIND_USERS: {
    scope: 'users',
  },
  ASSIGN_USER_ROLE: {
    scope: 'users',
  },
  UNASSIGN_USER_ROLE: {
    scope: 'users',
  },
  SUBSCRIBE_TO_CLIENT: {
    scope: 'subscribe',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  UNSUBSCRIBE_FROM_CLIENT: {
    scope: 'subscribe',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  FIND_ACCOUNT_SUBSCRIBER: {
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  FIND_ACCOUNT_SUBSCRIBERS: {
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  FIND_UNSUBSCRIBED_CLIENTS: {
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  FIND_UNSUBSCRIBED_USERS: {
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  VIEW_SUBSCRIPTIONS: {
    scope: 'user',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
};
